import styled from 'styled-components';
import {
  StyledDropdown as _StyledDropdown,
  StyledDropdownContentHeader as _StyledDropdownContentHeader,
} from 'components/HeaderDropdownMenu/styled';

import { getThemeProp } from 'theme';

export const SDropdown = styled(_StyledDropdown)`
  & {
    &.dropdown--active .dropdown__trigger:after {
      content: '\\3c';
    }

    .dropdown__trigger {
      color: ${getThemeProp('colors.fiordGrey')};
      font-size: 12px;
      font-weight: 400;
      padding: 0 36px 0 12.5px;
      cursor: pointer;

      &:hover {
        color: ${getThemeProp('colors.fiordGrey')};
      }

      &:before {
        background-color: ${getThemeProp('colors.concreteGrey')};
        content: '';
        height: 24px;
        left: 0;
        margin-top: -12px;
        position: absolute;
        top: 50%;
        width: 1px;
        opacity: 0.35;
      }

      &:after {
        color: ${getThemeProp('colors.solitudeGrey')};
        content: '\\3b';
        font-family: omilia-nlu-studio-v2;
        font-size: 6px;
        position: absolute;
        right: 22px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
`;

export const SDropdownContentHeader = styled(_StyledDropdownContentHeader)`
  height: 60px;
`;

export const SAvatar = styled.img`
  border: 1px solid;
  color: ${getThemeProp('colors.solitudeGrey')};
  border-radius: 50%;
  height: 26px;
  margin: 0 auto;
  object-fit: cover;
  padding: 0;
  width: 26px;
`;

export const SName = styled.div`
  color: ${getThemeProp('colors.fiordGrey')};
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 4px;
`;

export const SEmail = styled.div`
  color: ${getThemeProp('colors.fiordGrey')};
  font-size: 11px;
  font-weight: 300;
  line-height: 14px;
`;
